import React from 'react';
import { FormikFieldProps } from 'formik-antd/lib/FieldProps';
import { Field } from 'formik-antd';
import { FieldProps } from 'formik';

import BaseTextEditor, {
  ReactQuillProps,
  UnprivilegedEditor,
} from 'components/wrappers/BaseTextEditor';

export interface FormikTextEditorValue {
  content: string;
  editor?: UnprivilegedEditor;
}

type FormikTextEditorProps = ReactQuillProps & FormikFieldProps;

export default function FormikTextEditor({
  name,
  validate,
  fast,
  onChange,
  ...restProps
}: FormikTextEditorProps) {
  return (
    <Field name={name} validate={validate} fast={fast}>
      {({
        field: { value },
        form: { setFieldValue, setFieldTouched },
      }: FieldProps) => (
        <BaseTextEditor
          value={value.content || ''}
          onChange={(content, delta, source, editor) => {
            setFieldValue(name, { content, editor });
            onChange && onChange(content, delta, source, editor);

            setFieldTouched(name, true, false);
          }}
          onBlur={() => setFieldTouched(name, true, false)}
          {...restProps}
        />
      )}
    </Field>
  );
}
